import React from "react";
import { Modal } from "react-bootstrap";
import { ButtonComp } from "../../../../components";
import FallbackImage from "../../../../components/Common/ImageWrapper";
import { formatDate } from "../../../../utils/dateFormat";
import "./BranchTable.css";

const DetailField = ({ label, value, icon, className = "col-md-6" }) => (
  <div className={className}>
    <div className="view-branch-modal__field">
      <span className="view-branch-modal__label">{label}</span>
      <p className="view-branch-modal__value mb-0">
        {icon ? (
          <i className={`${icon} me-2 view-branch-modal__field-icon`} aria-hidden />
        ) : null}
        {value}
      </p>
    </div>
  </div>
);

const Section = ({ title, icon, children }) => (
  <div className="view-branch-modal__section">
    <h6 className="view-branch-modal__section-title">
      <i className={`${icon} me-2`} aria-hidden />
      {title}
    </h6>
    <div className="row g-2">{children}</div>
  </div>
);

const ViewBranch = ({ branchData, show, onHide }) => {
  if (!branchData) return null;

  const data = branchData.originalData || branchData;
  const {
    name,
    phone,
    email,
    address,
    photo,
    use_cooperative_logo,
    country,
    city,
    created_at,
  } = data;

  const countryName = typeof country === "object" ? country?.name : country;
  const cityName = typeof city === "object" ? city?.name : city;

  const safeName = name || "Unknown Branch";
  const safePhone = phone || "Not provided";
  const safeEmail = email || "Not provided";
  const safeAddress = address || "Not provided";
  const safeCreatedAt = created_at
    ? formatDate(created_at, "DD-MMM-YYYY")
    : "Not available";

  const shouldShowPhoto = !use_cooperative_logo && photo;

  const logoBadge = use_cooperative_logo ? (
    <span className="view-branch-modal__badge view-branch-modal__badge--secondary">
      <i className="fas fa-building me-1" aria-hidden />
      Uses Cooperative Logo
    </span>
  ) : (
    <span className="view-branch-modal__badge view-branch-modal__badge--primary">
      <i className="fas fa-image me-1" aria-hidden />
      Custom Logo
    </span>
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="view-branch-modal"
      dialogClassName="view-branch-modal__dialog"
    >
      <Modal.Header closeButton className="view-branch-modal__header border-0">
        <div className="d-flex align-items-center gap-3 w-100 pe-4">
          {shouldShowPhoto ? (
            <FallbackImage
              className="view-branch-modal__avatar"
              src={photo}
              alt="branch logo"
            />
          ) : (
            <div className="view-branch-modal__avatar view-branch-modal__avatar--placeholder">
              <i className="fas fa-building" aria-hidden />
            </div>
          )}
          <div className="flex-grow-1 min-w-0">
            <Modal.Title as="h5" className="view-branch-modal__title mb-0">
              {safeName}
            </Modal.Title>
            <p className="view-branch-modal__subtitle mb-0">Branch Details</p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="view-branch-modal__body">
        <Section title="Basic Information" icon="fas fa-building">
          <DetailField label="Branch Name" value={safeName} />
          <DetailField label="Logo Status" value={logoBadge} />
        </Section>

        <Section title="Contact Information" icon="fas fa-phone">
          <DetailField
            label="Phone Number"
            value={safePhone}
            icon="fas fa-phone"
          />
          <DetailField
            label="Email Address"
            value={safeEmail}
            icon="fas fa-envelope"
          />
        </Section>

        <Section title="Location Information" icon="fas fa-map-marker-alt">
          <DetailField
            label="Country"
            value={countryName || "Not specified"}
            icon="fas fa-globe"
          />
          <DetailField
            label="City/State"
            value={cityName || "Not specified"}
            icon="fas fa-city"
          />
          <DetailField
            label="Full Address"
            value={safeAddress}
            icon="fas fa-map-marker-alt"
            className="col-12"
          />
        </Section>

        <Section title="Additional Information" icon="fas fa-info-circle">
          <DetailField
            label="Created Date"
            value={safeCreatedAt}
            icon="fas fa-calendar"
          />
          {shouldShowPhoto ? (
            <div className="col-md-6">
              <div className="view-branch-modal__field">
                <span className="view-branch-modal__label">Branch Logo</span>
                <FallbackImage
                  className="view-branch-modal__logo-preview"
                  src={photo}
                  alt="branch logo"
                />
              </div>
            </div>
          ) : null}
        </Section>
      </Modal.Body>

      <Modal.Footer className="view-branch-modal__footer border-0">
        <ButtonComp
          btnText="Close"
          onClick={onHide}
          btnClassName="view-branch-modal__close-btn px-4 py-2"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ViewBranch;
